<template>
    <div
        class="grid h-10 w-40 grid-cols-4 rounded-md border border-gray-300 shadow-button"
    >
        <div
            class="flex cursor-pointer items-center justify-center border-r border-gray-300"
            @click="
                modelValue > min
                    ? $emit('update:modelValue', modelValue - 1)
                    : null
            "
        >
            <MinusCircleIcon class="h-4 w-4 text-gray-500" />
        </div>
        <input
            :value="modelValue"
            type="number"
            :min="min"
            :max="max"
            class="select-te col-span-2 text-center text-sm text-gray-600 focus:outline-hidden"
            @input="onInput"
        />
        <div
            class="flex cursor-pointer items-center justify-center border-l border-gray-300"
            @click="
                modelValue < max
                    ? $emit('update:modelValue', modelValue + 1)
                    : null
            "
        >
            <PlusCircleIcon class="h-4 w-4 text-gray-500" />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { MinusCircleIcon, PlusCircleIcon } from "@heroicons/vue/24/solid";

defineProps<{
    min: number;
    max: number;
    modelValue: number;
}>();

const emit = defineEmits<{
    (e: "update:modelValue", value: number): void;
}>();

const onInput = (e: Event) => {
    const inputEvent = e.target as HTMLInputElement;

    if (inputEvent.value !== null) {
        emit("update:modelValue", inputEvent.value);
    }
};
</script>
